import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardTextD.module.scss';

const CardTextD = (props) => {
  const {
    heading,
    contentMarkup,
    buttons = [],
  } = props;

  return [
    <div key='cardTextD-container' className={classes.container}>
      <div className={classes.wrapper}>
        {heading &&
          <h3
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
      </div>
      {buttons.length > 0 &&
      <div className={classes.itemsContainer}>
        {buttons.map((item, i) => (
          <div className={classes.button} key={i}>
            {BuildChildren(item)}
          </div>
        ))}
      </div>}
    </div>,
  ];
};

CardTextD.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * List of buttons
  */
  buttons: PropTypes.array,
};

export default CardTextD;
